import { render, staticRenderFns } from "./IdentityVerify.vue?vue&type=template&id=47dad905&scoped=true&"
import script from "./IdentityVerify.vue?vue&type=script&lang=js&"
export * from "./IdentityVerify.vue?vue&type=script&lang=js&"
import style0 from "./IdentityVerify.vue?vue&type=style&index=0&id=47dad905&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dad905",
  null
  
)

export default component.exports